import * as React from 'react';
import { MediaQuery, Price } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';

const LensPacksItem = ({ onChange , value , isSelected , item , useIncludedLensPack ,  })=>{
    const currentBreakpoint = MediaQuery.useBreakpoint();
    const { currency , getLabel  } = useIntl();
    const handleChange = ()=>{
        onChange(value);
    };
    const getDioptries = (str)=>{
        return str.replace(/[a-zA-Z]/g, '').replace(/\s+/g, '').replace(/[{()}]/g, '');
    };
    const thickness = item.thickness.split('(')[0];
    const dioptries = getDioptries(item.thickness);
    const isSelectedClass = isSelected ? '_is_selected' : '';
    const priceInCents = item.priceInCents;
    if (!isDefined(priceInCents)) {
        console.error(`No price found for pack with packType "${item.pack.key}"`);
        return null;
    }
    if (currentBreakpoint === MediaQuery.BreakpointName.PHONE || currentBreakpoint === MediaQuery.BreakpointName.TABLET_PORTRAIT || currentBreakpoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE) {
        return /*#__PURE__*/ React.createElement("label", {
            className: `lens-packs-accordion-item lens-packs-accordion-item--${item.pack.key} ${isSelectedClass}`
        }, /*#__PURE__*/ React.createElement("div", {
            className: "lens-packs-accordion-item__header"
        }, /*#__PURE__*/ React.createElement("input", {
            className: "lens-packs-accordion-item__radio",
            type: "radio",
            name: "ssp-lens-pack",
            value: item.pack.key,
            "aria-checked": isSelected,
            checked: isSelected,
            onChange: handleChange
        }), /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest"
        }, item.pack.label)), /*#__PURE__*/ React.createElement("div", {
            className: "lens-packs-accordion-item__body"
        }, /*#__PURE__*/ React.createElement("ul", null, item.benefits.map((benefit)=>benefit.value && /*#__PURE__*/ React.createElement("li", {
                key: benefit.name
            }, getLabel(benefit.labelKey))
        )), /*#__PURE__*/ React.createElement("div", {
            className: "lens-packs-accordion-item__price"
        }, item.isIncluded ? getLabel('products.included') : /*#__PURE__*/ React.createElement(React.Fragment, null, "+ ", /*#__PURE__*/ React.createElement(Price, {
            value: priceInCents,
            centAmount: true,
            currency: currency
        }))), !item.isIncluded && !!item.voucherValue && /*#__PURE__*/ React.createElement("p", {
            className: "lens-packs-accordion-item__voucher"
        }, getLabel('products.ssp.voucher.label'), /*#__PURE__*/ React.createElement(Price, {
            value: item.voucherValue,
            centAmount: true,
            currency: currency
        }))));
    } else {
        const higherTitle = item.visualField ? 'lens-packs-cell--title--with-visual-field' : '';
        return /*#__PURE__*/ React.createElement("label", {
            className: `lens-packs-column ${isSelectedClass}`
        }, /*#__PURE__*/ React.createElement("div", {
            className: `lens-packs-cell lens-packs-cell--type lens-packs-cell--${item.pack.key}`
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "smallest"
        }, item.pack.label)), /*#__PURE__*/ React.createElement("div", {
            className: `lens-packs-cell lens-packs-cell--title ${higherTitle}`
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "subheading1"
        }, thickness), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("small", {
            className: "lens-packs-cell__dioptry"
        }, "(", dioptries, " ", getLabel('products.unit.dioptries'), ")")), item.visualField && /*#__PURE__*/ React.createElement("small", {
            className: "lens-packs-cell__visual-field"
        }, item.visualField)), item.benefits.map((benefit)=>{
            const checked = benefit.value ? 'check' : 'no-check';
            return /*#__PURE__*/ React.createElement("div", {
                key: benefit.name,
                className: `lens-packs-cell lens-packs-cell--${checked}`
            });
        }), /*#__PURE__*/ React.createElement("div", {
            className: "lens-packs-cell lens-packs-cell--footer"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "lens-packs-cell__price"
        }, useIncludedLensPack && item.isIncluded ? getLabel('products.included') : /*#__PURE__*/ React.createElement("span", null, useIncludedLensPack && '+ ', ' ', /*#__PURE__*/ React.createElement(Price, {
            value: priceInCents,
            centAmount: true,
            currency: currency
        }))), !item.isIncluded && !!item.voucherValue && /*#__PURE__*/ React.createElement("p", {
            className: "lens-packs-cell__voucher"
        }, /*#__PURE__*/ React.createElement("small", null, getLabel('products.ssp.voucher.label')), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Price, {
            value: item.voucherValue,
            centAmount: true,
            currency: currency
        })), /*#__PURE__*/ React.createElement("input", {
            className: "lens-packs-cell__radio",
            type: "radio",
            name: "ssp-lens-pack",
            value: item.pack.key,
            "aria-checked": isSelected,
            checked: isSelected,
            onChange: handleChange
        })));
    }
};
var LensPacksItem$1 = LensPacksItem;

export { LensPacksItem, LensPacksItem$1 as default };
//# sourceMappingURL=LensPacksItem.js.map
